"use client"

import { useState, useEffect, useRef } from "react"

import axios from "axios"
import toast, { Toaster } from 'react-hot-toast';
import {
    createMentorRequest,
    getRequestsByStartup,
    getAllMentors,
    getStartupProfile,
} from "../utils/api"
import { Link, useNavigate } from "react-router-dom"
import { LocateIcon } from "lucide-react"
import { FaCity, FaSearch } from "react-icons/fa"
import { ChevronLeft, ChevronRight, Filter, ChevronDown, FactoryIcon } from "lucide-react"
import '../index.css'
import Skeleton from "react-loading-skeleton"

export default function CoWorkingSpaces() {
    const [sidebarOpen, setSidebarOpen] = useState(false)
    const [isMobile, setIsMobile] = useState(false)
    const [fullName, setFullName] = useState("")
    const [email, setEmail] = useState("")
    const [mentors, setMentors] = useState([])
    const [loading, setLoading] = useState(true)
    const [facility, setfacility] = useState([])
    const [data, setData] = useState([])
    const [currentPage, setCurrentPage] = useState(1)
    const [filterdData, setFilteredData] = useState([])
    const [selectedFacility, setSelectedFacility] = useState()
    const navigate=useNavigate()



    const toggleSidebar = () => setSidebarOpen((prev) => !prev)

    useEffect(() => {
        const handleResize = () => {
            const mobile = window.innerWidth < 768
            setIsMobile(mobile)
            if (mobile) setSidebarOpen(false)
        }

        handleResize()
        window.addEventListener("resize", handleResize)
        window.addEventListener("orientationchange", () => {
            setTimeout(handleResize, 100)
        })

        return () => {
            window.removeEventListener("resize", handleResize)
            window.removeEventListener("orientationchange", handleResize)
        }
    }, [])

    const fetchCummaAPI = async () => {
        try {
            const { data } = await axios.get(`https://api.cumma.in/api/service-providers/sharedserviceprovider`)
            console.log(data)
            let all = "all"
            setfacility(["all companies", ...data.uniqueFacilityTypes])
            setData(data.data)
            setFilteredData(data.data)

        } catch (error) {
            console.log("Something went wrong")
        }
    }

    const CompanyPerPage = 9
    const totalPages = Math.ceil(data?.length / CompanyPerPage)

    
  const [open, setOpen] = useState(false);
const [inputValue,setInputValue]=useState("")
const [dummyData,setDummyData]=useState([])
 

  





    useEffect(() => {
        const fetchData = async () => {
            try {
                const startupId = localStorage.getItem("startupId");

                const [profileResRaw, mentorsResRaw, requestsResRaw] = await Promise.all([
                    getStartupProfile(startupId),
                    getAllMentors(),
                    getRequestsByStartup(startupId),
                ]);

                // Normalize profile
                const profile =
                    profileResRaw?.data ??
                    profileResRaw ?? {};

                // Normalize mentors -> produce an array
                const mentorsData =
                    Array.isArray(mentorsResRaw)
                        ? mentorsResRaw
                        : mentorsResRaw?.data ??
                        mentorsResRaw?.data?.data ??
                        [];

                // Normalize requests -> produce an array
                const requestsData =
                    Array.isArray(requestsResRaw)
                        ? requestsResRaw
                        : requestsResRaw?.data ??
                        requestsResRaw?.data?.data ??
                        [];

                // Set profile fields safely
                setFullName(profile.fullName ?? profile.name ?? localStorage.getItem("startupName") ?? "");
                setEmail(profile.email ?? "");

                // Filter only active mentors
                const activeMentors = mentorsData.filter((m) => {
                    if (m == null) return false;
                    const val = m.isActive;
                    return val === true || Number(val) === 1 || String(val) === "1";
                });

                // Extract requested mentor ids
                const requestedMentorIds = (requestsData || []).map((r) => {
                    return r?.mentor_id?._id ?? r?.mentor_id ?? r?.mentorId ?? null;
                }).filter(Boolean);

                // Build final mentors list with `requested` boolean
                setMentors(
                    activeMentors.map((mentor) => ({
                        ...mentor,
                        requested: requestedMentorIds.includes(mentor._id),
                    }))
                );

            } catch (err) {
                console.error("Error fetching data:", err);
               
            } finally {
                setLoading(false);
            }
        };

        fetchData();
        fetchCummaAPI()
    }, []);

    useEffect(() => {
        if (data) {


            const lastIndex = currentPage * CompanyPerPage
            const firstIndex = lastIndex - CompanyPerPage

            const filteredCompany = data.slice(firstIndex, lastIndex)
            console.log(filteredCompany)
            setFilteredData(filteredCompany)
            setDummyData(filteredCompany)
        }

    }, [data, currentPage])


     useEffect(() => {
    if (!data) return;
    if(!inputValue){
      setFilteredData(dummyData)
      return
    }

    // Step 1: Filter by location
  const locationFiltered = data.filter(company => {
        const search = inputValue.toLowerCase();

        const cityMatch =
            company.city?.toLowerCase().includes(search);

        const stateMatch =
            company.stateProvince?.toLowerCase().includes(search);

        return cityMatch || stateMatch;
    });

    // Step 2: Pagination
    const lastIndex = currentPage * CompanyPerPage;
    const firstIndex = lastIndex - CompanyPerPage;

    const paginatedCompanies = locationFiltered.slice(firstIndex, lastIndex);

    setFilteredData(paginatedCompanies);

}, [data, currentPage, inputValue]);


    const nextClick = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1)
        }
    }

    const backwardsClick = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1)
        }
    }

    const onCategoryClick = (category) => {
        if (!category) return setFilteredData(data);

        if (category == "all companies") return setFilteredData(data);

        setSelectedFacility(category)

        const filterByCategory = data.filter((each) => each.facilityTypes.includes(category))
        setFilteredData(filterByCategory)
    }

    const onViewClick = (id) => {
        navigate(`/view-details/${id}`)
    }


    const [isDropdownOpen, setIsDropdownOpen] = useState(false)
    const [canScrollLeft, setCanScrollLeft] = useState(false)
    const [canScrollRight, setCanScrollRight] = useState(true)
    const scrollContainerRef = useRef(null)
    const [sortBy, setSortBy] = useState("Newest")

    const scroll = (direction) => {
        if (scrollContainerRef.current) {
            const scrollAmount = 300
            scrollContainerRef.current.scrollBy({
                left: direction === "left" ? -scrollAmount : scrollAmount,
                behavior: "smooth",
            })
        }
    }

//    const itemsPerPage = 6
//   const totalItems = 29
//   const totalPages = Math.ceil(totalItems / itemsPerPage)

  const handleScroll = (direction) => {
    const container = document.getElementById("category-scroll")
    if (container) {
      const scrollAmount = 300
      if (direction === "left") {
        container.scrollBy({ left: -scrollAmount, behavior: "smooth" })
      } else {
        container.scrollBy({ left: scrollAmount, behavior: "smooth" })
      }
    }
  }

    

const handleSelect = (option) => {
  setSortBy(option);
  setOpen(false);

  // Sort based on createdAt
  
};



useEffect(() => {
  if (!data || data.length === 0) return;

  // Sort first
  let sortedData = [...data];
  if (sortBy === "Newest") {
    sortedData.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
  } else if (sortBy === "Oldest") {
    sortedData.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));
  }

  // Then paginate
  const lastIndex = currentPage * CompanyPerPage;
  const firstIndex = lastIndex - CompanyPerPage;
  const paginatedData = sortedData.slice(firstIndex, lastIndex);

  setFilteredData(paginatedData);
}, [data, currentPage, sortBy]);



    return (
        <>
            <div className="flex h-screen w-screen bg-gradient-to-br">
           
                <Toaster position="top-right" reverseOrder={false} />



                {/* Main Content */}
                <div
                  className={`flex flex-col flex-1 transition-all duration-300 min-h-0 ${!isMobile ? "ml-16 sm:ml-18 md:ml-20 lg:ml-20 xl:ml-20" : "ml-0"
                    }`}
                >
                    {/* Header */}
         
                    {/* Page Content */}

                   
               {loading?<div className="p-6 space-y-8">
    {/* Filter Bar Skeleton */}
    <div className="flex items-center gap-4">
      <Skeleton circle width={40} height={40} />
      <Skeleton width={500} height={40} />
      <Skeleton circle width={40} height={40} />
      <Skeleton width={100} height={40} />
    </div>

    {/* Facilities Grid Skeleton */}
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-8">
      {Array.from({ length: 6 }).map((_, i) => (
        <div key={i} className="bg-white rounded-lg border border-gray-200 p-4">
          <Skeleton height={180} borderRadius={8} />

          <div className="mt-4">
            <Skeleton height={20} width="80%" />
            <Skeleton height={16} width="90%" />
            <Skeleton height={16} width="70%" />
          </div>

          <div className="mt-6 flex justify-between items-center">
            <div>
              <Skeleton height={12} width={60} />
              <Skeleton height={20} width={80} />
            </div>
            <Skeleton height={36} width={100} borderRadius={8} />
          </div>
        </div>
      ))}
    </div>
  </div>:

                     <main className="flex-1 p-4 xs:p-6 sm:p-8 overflow-y-auto min-h-0">
      {/* Category Filter Bar */}
      <div className="border-b border-gray-200">
        <div className="w-full px-4 py-6">
          <div className="flex items-center gap-4">
            {/* Left Scroll Button */}
            <button
              onClick={() => handleScroll("left")}
              className="flex-shrink-0 p-2 hover:bg-gray-100 rounded-lg transition-colors"
            >
              <ChevronLeft size={20} className="text-gray-600" />
            </button>

            {/* Categories Container */}
            <div id="category-scroll"  className="flex-auto min-w-0 overflow-x-auto scrollbar-hide scroll-container">
              <div className="inline-flex gap-8 pb-2 ">
                {facility.map((category) => (
                  <button
                    key={category.id}
                    onClick={() => onCategoryClick(category)}
                    className={`flex flex-col items-center gap-2 px-2 py-2 whitespace-nowrap transition-colors ${
                      selectedFacility === category ? "text-black underline" : "text-gray-600 hover:text-gray-900"
                    }`}
                  >
                    <span className="text-2xl">{category?.icon}</span>
                    <span className="text-xs font-medium text-center">{category?.toUpperCase()}</span>
                  </button>
                ))}
              </div>
            </div>

            {/* Right Scroll Button */}
            <button
              onClick={() => handleScroll("right")}
              className="flex-shrink-0 p-2 hover:bg-gray-100 rounded-lg transition-colors"
            >
              <ChevronRight size={20} className="text-gray-600" />
            </button>

            {/* Filters Button */}
           
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="w-full px-4 py-8">
       
        {/* Header Section */}
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-8">
          <div>
            <h1 className="text-4xl font-bold text-gray-900 mb-2">All Workspaces</h1>
            <p className="text-gray-500">Showing 1-{totalPages} of {data?.length} results</p>
          </div>

          {/* Sort Dropdown */}
           <div className="flex items-center gap-3 relative">
      <span className="text-gray-600 font-medium">Sort by</span>
      <div className="relative">
        <button
          onClick={() => setOpen(!open)}
          className="flex items-center gap-2 px-4 py-2 border border-gray-300 rounded-lg bg-white hover:bg-gray-50 text-gray-900 font-medium"
        >
          {sortBy}
          <ChevronDown size={18} className={`transition-transform ${open ? "rotate-180" : ""}`} />
        </button>

        {open && (
          <div className="absolute right-0 mt-2 w-40 bg-white border border-gray-200 rounded-lg shadow-lg z-10">
            <button
              onClick={() => handleSelect("Newest")}
              className={`block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-100 ${
                sortBy === "Newest" ? "bg-gray-50 font-semibold" : ""
              }`}
            >
              Newest
            </button>
            <button
              onClick={() => handleSelect("Oldest")}
              className={`block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-100 ${
                sortBy === "Oldest" ? "bg-gray-50 font-semibold" : ""
              }`}
            >
              Oldest
            </button>
          </div>
        )}
      </div>
    </div>
        </div>

          <div className="relative mb-10">
                            <input
                              type="text"
                              name="name"
                           onChange={(e)=>setInputValue(e.target.value)}
                           value={inputValue}
                              placeholder="Search by Location..."
                              className="w-full px-4 py-4 pl-12 bg-white/70 backdrop-blur-sm border border-gray-600/50 rounded-2xl focus:outline-none focus:ring-2 focus:ring-blue-500/50 focus:border-transparent transition-all duration-300 hover:shadow-lg text-sm"
                            />
                            <FaSearch className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400" />
                          </div>

        {/* Facilities Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12 ">
          {filterdData.map((facility) => (
            <div
              key={facility.id}
              className="bg-white rounded-lg overflow-hidden border border-gray-200 hover:shadow-lg transition-shadow"
            >
              {/* Image Container */}
              <div className="relative h-48 bg-gray-200 overflow-hidden">
                <img
                  src={facility?.images?.length>0?facility?.images[0]: "/placeholder.svg"}
                  alt={facility.name}
                  className="w-full h-full object-cover"
                />
                {facility.featured && (
                  <div className="absolute top-0 left-0 bg-green-500 text-white px-3 py-1 text-sm font-bold">
                    FEATURED
                  </div>
                )}
                {/* Logo Badge */}
                <div className="absolute bottom-3 left-3 bg-white rounded-lg p-2 shadow-md">
                  <div className="w-8 h-8 bg-gray-200 rounded flex items-center justify-center text-xs font-bold text-gray-600">
                    📐
                  </div>
                </div>
              </div>

              {/* Content */}
              <div className="p-4">
                <h3 className="text-lg font-bold text-gray-900 mb-2 line-clamp-2">{facility.serviceName}</h3>
                <p className="text-sm text-gray-600 mb-4 line-clamp-2">{facility.address}</p>

                {/* Price and Button */}
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-xs text-gray-500 mb-1">Starting from</p>
                    <p className="text-xl font-bold text-gray-900">{facility.price}</p>
                  </div>
                  <button className="px-6 py-2 border-2 border-black-500 text-black-600 font-semibold rounded-lg hover:bg-black-800 transition-colors" onClick={()=>onViewClick(facility._id)}>
                    View Details
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
        

        {/* Pagination */}
        <div className="flex flex-col items-center gap-4">
          <div className="flex items-center gap-2">
            <button onClick={backwardsClick} className="px-3 py-2 text-gray-600 hover:bg-gray-100 rounded-lg transition-colors">Previous</button>

            {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
              <button
                key={page}
                onClick={() => setCurrentPage(page)}
                className={`w-5 h-7 rounded-lg font-medium transition-colors ${
                  currentPage === page ? "bg-gray-500 text-white" : "text-gray-600 hover:bg-gray-100"
                }`}
              >
                {page}
              </button>
            ))}

            <button className="px-3 py-2 text-gray-600 hover:bg-gray-100 rounded-lg transition-colors" onClick={nextClick}>Next</button>
          </div>

          <p className="text-sm text-gray-500">Showing 1-6 of {data.length} results</p>
        </div>
      </div>
    </main>

        }















                </div>










            </div>



        </>
    )
}